import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ProjectInterest } from '@app/models/project.models';
import { v4 as uuidv4 } from 'uuid';

export interface ApplicableInterestRatesFormValue {
  id: string;
  investedAmount: number | null;
  annualInterestCommitment: number | null;
  totalInterest: number | null;
}

export interface ApplicableInterestRatesFormGroup {
  id: FormControl<string>;
  investedAmount: FormControl<number | null>;
  annualInterestCommitment: FormControl<number | null>;
  totalInterest: FormControl<number | null>;
}

export function getApplicableInterestRatesFormGroup(
  fb: FormBuilder
): FormGroup<ApplicableInterestRatesFormGroup> {
  return fb.nonNullable.group({
    id: fb.nonNullable.control<string>(uuidv4()),
    investedAmount: fb.control<number | null>(null),
    annualInterestCommitment: fb.control<number | null>(null),
    totalInterest: fb.control<number | null>(null),
  });
}

export function getProjectInterestFromApplicableInterestRatesFormValue(
  formGroup: FormGroup<ApplicableInterestRatesFormGroup>
): ProjectInterest {
  return {
    amount: formGroup.controls.investedAmount.value!,
    interest: formGroup.controls.annualInterestCommitment.value!,
  };
}

export function getApplicableInterestRatesFormValueFromProjectInterest(
  response: ProjectInterest
): ApplicableInterestRatesFormValue {
  return {
    id: uuidv4(),
    investedAmount: response.amount,
    annualInterestCommitment: response.interest,
    totalInterest: null, //TODO apply logic
  };
}
